import * as React from "react";
import { useMappedState } from "redux-react-hook";
import _ from "lodash";
import { useHistory } from "react-router-dom";

import { useNotificationBannerContext } from "src/core/shared/context//NotificationBanner/NotificationBannerContext";
import { IPermission } from "src/core/shared/api/roles.api";
import { useDrop } from "src/core/drops/hooks";
import { useCurrentUser } from "src/core/users/hooks";
import { IStore } from "src/core/shared/store";
import useTerminology from "src/core/shared/hooks/useTerminology";

const bannerId = "default-payment-card";
export const useDefaultCardNotification = () => {
  const {
    notify, hideBanner, banners
  } = useNotificationBannerContext();

  const paymentSettings = useMappedState((store: IStore) => store.global.settings?.payment);
  const terminology = useTerminology();
  const [ { drop } ] = useDrop();
  const [ { currentRole } ] = useCurrentUser();
  const history = useHistory();

  // On drop change
  React.useEffect(() => {
    if (!paymentSettings?.preauthorizationsEnabled || currentRole?.type === "admin") {
      return;
    }
    const dropRequiresPaymentMethod = !drop?.defaultPaymentCardId && drop?.groupedSettings?.require_payment_method?.value.required;
    const hasPaymentBanner = _.find(banners, banner => banner.id === bannerId);

    if (hasPaymentBanner) {
      if (!dropRequiresPaymentMethod) {
        hideBanner(bannerId);
      } else {
        return;
      }
    } else {
      if (dropRequiresPaymentMethod) {
        const amendPaymentMethodPermission = _.find<IPermission>(currentRole?.permissions, permission => permission.code === "amend-payment-method");
        let message = `A payment method must be assigned to this ${terminology?.drop.singular.text} before orders will be processed and delivered.`;

        // Set the message differently if the customer does not have the permission
        // to assign a drop to the the card
        if (!amendPaymentMethodPermission) {
          message = `${message} Please contact another peer with the relevant permissions to setup payment details.`;
        }

        notify({
          id: bannerId,
          dismissible: false,
          duration: 0,
          message,
          type: "error",
          button: amendPaymentMethodPermission ? {
            label: "Configure",
            onClick: () => history.push("/settings/user#payment_methods")
          } : undefined
        });
      }
    }

    if (dropRequiresPaymentMethod) {
      if (!_.find(banners, banner => banner.id === "payment-card")) {
        notify;
      }
    }
  }, [
    banners,
    currentRole?.permissions,
    drop?.defaultPaymentCardId,
    drop?.groupedSettings?.require_payment_method?.value.required,
    hideBanner,
    history,
    notify,
    paymentSettings?.preauthorizationsEnabled,
    terminology?.drop.singular.text
  ]);
};
